/**
 * Route for the purchase order controls screen (P45 U71, FSD 4.2.5.4). INT spreads
 * `ORDER_CONTROL_ROUTES` into `PROCUREMENT_ROUTES` (routes.ts is shared by parallel packets).
 * Reached from the purchase-order list header; no nav item of its own. Literal path (R3).
 */

import type { RouteRecordRaw } from 'vue-router'

export const ORDER_CONTROL_ROUTES: RouteRecordRaw[] = [
  {
    path: '/procurement/order-controls',
    name: 'procurement-order-controls',
    component: () => import('@/modules/procurement/orders/PoControlSettingsView.vue'),
    meta: {
      titleKey: 'procurement.u71.controls.title',
      permission: 'procurement.settings.read',
    },
  },
]
